.footer {
  display: flex;
  justify-content: flex-end;
  gap: 8;
  margin-top: var(--ant-margin-lg);
}

.btn {
  margin: 0 var(--ant-margin-xs);
}

.description {
  margin-bottom: var(--ant-margin);
}
